import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { CartOutlets } from '@spartacus/cart/base/root';
import { Order, OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { EfaOrderSummaryComponent } from '../../../shared/components/efa-order-summary/efa-order-summary.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-order-confirmation-totals',
    templateUrl: './efa-order-confirmation-totals.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EfaOrderSummaryComponent, AsyncPipe, TranslatePipe]
})
export class EfaOrderConfirmationTotalsComponent implements OnDestroy {

  readonly cartOutlets = CartOutlets;
  order$: Observable<Order | undefined> = this.orderFacade.getOrderDetails();

  constructor(protected orderFacade: OrderFacade) {}

  ngOnDestroy() {
    this.orderFacade.clearPlacedOrder();
  }

}
